// This file uses the non-accessible mantine tooltip to show the tooltip.
// eslint-disable-next-line no-restricted-imports
import { Tooltip } from '@mantine/core';
import { ReactNode, useEffect, useState } from 'react';
import styles from './AccessibleTooltip.module.css';
import { useMediaQuery } from '@mantine/hooks';

export type AccessibleTooltipProps = Parameters<typeof Tooltip>[0] & {
    children: ReactNode;
};

export const AccessibleTooltip: React.FC<AccessibleTooltipProps> = ({
    children,
    ...props
}) => {
    const isTouchDevice = useMediaQuery('(pointer: coarse)');

    const [open, setOpen] = useState(false);

    // Allow closing tooltip on outside click.
    useEffect(() => {
        if (!open) return;

        function close() {
            setOpen(false);
        }

        document.addEventListener('click', close);

        return () => {
            document.removeEventListener('click', close);
        };
    }, [open]);

    if (isTouchDevice) {
        return (
            // Use multiline (word wrap) by default because the tooltip width
            // might exceed the screen width.
            <Tooltip multiline {...props} opened={open}>
                <button
                    className={styles.button}
                    onClick={(e) => {
                        setOpen((v) => !v);
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    {children}
                </button>
            </Tooltip>
        );
    }

    return <Tooltip {...props}>{children}</Tooltip>;
};

/**
 * Warning: Making this a React component will cause the tooltip to not show
 * up on hover. Reason for this (bug?) is unknown. */
export const asteriskTooltipTarget = (
    <sup className={styles.tooltipTarget}>*</sup>
);
